// src/assets/assets.js
import cpp from "./c++icon.png";
import java from "./javaicon.png";
import python from "./pythonicon.jpeg";
import nodejs from "./nodejs.png";
import reactjs from "./reactjs.png";
import html from "./html.png";
import js from "./js.png";
import css from "./css.png";
import sql from "./sql.png";
import mongodb from "./mongodb.png";
import bail from "./bail.png";
import vaccine from "./vaccine.png";
import truck from "./truck.png";
import kisan from "./kisan.png";
import news from "./news.png";
import speechify from "./speechify.png"
import taskManagement from "./taskManagement.png"
import pratik_photo from "./pratikphoto.png"
import codemesher from "./codemesher.png"
const assets = {
  cpp,
  java,
  python,
  nodejs,
  reactjs,
  html,
  js,
  css,
  sql,
  mongodb,
  vaccine,
  bail,
  truck,
  kisan,
  news,
  speechify,
  taskManagement,
  pratik_photo,
  codemesher
};

export default assets;

